export default __webpack_public_path__ + "fonts/1942-webfont.woff2";